// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__36Ky7","signatureBlock":"Footer_signatureBlock__slXdO","signature":"Footer_signature__34ZfU"};